// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2HG1A","row":"ProcedureTreatmentSummary_row__3xoFK"};